<template>
  <div class="detail-biz-info">
    <div class="base-item">
      <div class="title">{{ $t('dms_device_detail_biz_info.she_bei_xin_xi') }}</div>
      <div class="row">
        <!--
          项目，区域，项目负责人（需要从项目列表中取人+电话），业务状态
          库存方，设备预估类型，分成预估类别，首次启租日期，
          累计租赁月数，累计违约次数，累计总部租金（HQ/PF可见）,固定资产编号（HQ/PF可见）
          翻新次数，F类租赁月数，F类总部租金
        -->
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.xiang_mu') }}</div>
          <div class="val">{{ bizInfo.locationName || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.qu_yu') }}</div>
          <div class="val">{{ bizInfo.siteName || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.xiang_mu_fu_ze_ren') }}</div>
          <div class="val">
            <template v-if="bizInfo.projectContactName">{{ bizInfo.projectContactName }}({{ bizInfo.projectContactPhone || '-' }})</template>
            <template v-else>-</template>
          </div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ye_wu_zhuang_tai') }}</div>
          <div class="val">{{ getDicValue('order_device_biz_state', bizInfo.bizState) || '-' }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ku_cun_fang') }}</div>
          <div class="val">{{ bizInfo.orgName || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.sbyglx') }}</div>
          <div class="val">{{ bizInfo.nextDeviceBizType || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.fcyglb') }}</div>
          <div class="val">{{ getDicValue('crm_sharing_rule_type', bizInfo.sharingClass) || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.shou_ci_qi_zu_ri_qi') }}</div>
          <div class="val">{{ $momentLocal(bizInfo.firstRentalTime, 'YYYY-MM-DD') || '-' }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ljzlysbhzs') }}</div>
          <div class="val">{{ bizInfo.totalReceivedMonthHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ljwycs') }}</div>
          <div class="val">{{ bizInfo.totalBreakCount || '-' }}</div>
        </div>
        <!-- 累计总部租金（HQ/PF可见）,固定资产编号（HQ/PF可见）  -->
        <div class="col" v-if="bizType === 'HQ' || bizType === 'PF'">
          <div class="key">{{ $t('dms_device_detail_biz_info.ljzbzj') }}</div>
          <div class="val">{{ bizInfo.totalReceivedRentalHq || '-' }}</div>
        </div>
        <div class="col" v-if="bizType === 'HQ' || bizType === 'PF'">
          <div class="key">{{ $t('dms_device_detail_biz_info.gdzcbh') }}</div>
          <div class="val">{{ bizInfo.fixAssetCode || '-' }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ljjzzlys') }}</div>
          <div class="val">{{ bizInfo.totalReceivedMonthBasicHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ljzspjzlys') }}</div>
          <div class="val">{{ bizInfo.totalGiveawayReceivedMonthHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ljzspjjzzlys') }}</div>
          <div class="val">{{ bizInfo.totalGiveawayReceivedMonthBasicHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.fan_xin_ci_shu') }}</div>
          <div class="val">{{ bizInfo.renovateNum || '-' }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.fxzlys') }}</div>
          <div class="val">{{ bizInfo.receivedMonthHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.fxjzzlys') }}</div>
          <div class="val">{{ bizInfo.renovateReceivedMonthBasicHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.fxzbzj') }}</div>
          <div class="val">{{ bizInfo.receivedRentalHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.fxzspjzlys') }}</div>
          <div class="val">{{ bizInfo.giveawayReceivedMonthHq || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.fxzspjjzzlys') }}</div>
          <div class="val">{{ bizInfo.giveawayReceivedMonthBasicHq || '-' }}</div>
        </div>
      </div>
      <div class="row">
      <div class="col">
        <div class="key">{{ $t('dms_device_detail_biz_info.ljzsys') }}</div>
        <div class="val">{{ bizInfo.totalGiveawayMonth || '-' }}</div>
      </div>
    </div>
    </div>

    <!-- v-if="deviceInfo.orderId" -->
    <div class="base-item">
      <div class="title">{{ $t('dms_device_detail_biz_info.ding_dan_xin_xi') }}</div>
      <div class="row">
        <!--
          合同编号，手工合同号，签订日期，订单类型，
          集团客户，租赁方，启租人，使用地点，
          启租时间，租赁时长（与现在一样后加单位），到期时间，支付周期，
          代理公司，业务员，售后公司，售后负责人（人+电话）

          isRentalSalesOrders orderClass 40 租售订单
            租赁方  ->购买方  启租人 ->销售人   去掉  原使用地点 ->使用地点
            启租时间 ->售卖时间  租赁时长 ->服务时长 支付周期  ->数据到期时间
        -->
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.he_tong_bian_hao') }}</div>
          <div class="val">{{ bizInfo.contractNo || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.sghtbh') }}</div>
          <div class="val">{{ bizInfo.customContractNo || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.qian_ding_ri_qi') }}</div>
          <div class="val">{{ $momentLocal(bizInfo.signingDate, 'YYYY-MM-DD') }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ding_dan_lei_xing') }}</div>
          <div class="val">{{ getDicValue('crm_contract_type', bizInfo.orderType) || '-' }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ji_tuan_ke_hu') }}</div>
          <div class="val">{{ bizInfo.bigCustomerName || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ isRentalSalesOrders?$t('dms_device_detail_biz_info.gou_mai_fang'):$t('dms_device_detail_biz_info.zu_lin_fang') }}</div>
          <div class="val">{{ bizInfo.customerName || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ isRentalSalesOrders?$t('dms_device_detail_biz_info.xiao_shou_ren'):$t('dms_device_detail_biz_info.qi_zu_ren') }}</div>
          <div class="val">
            {{ bizInfo.rentalUser || '-' }}
          </div>
        </div>
        <div class="col">
          <div class="key">{{ isRentalSalesOrders?$t('dms_device_detail_biz_info.shi_yong_di_dian'):$t('dms_device_detail_biz_info.shi_yong_di_dian') }}</div>
          <div class="val">{{ bizInfo.useLocation || '-' }}</div>
        </div>
        <!-- 使用地点 -->
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{ isRentalSalesOrders?$t('dms_device_detail_biz_info.shou_mai_shi_jian'):$t('dms_device_detail_biz_info.qi_zu_shi_jian') }}</div>
          <div class="val">{{ momentAmPm($momentLocal(bizInfo.rentalStartTime) || '-') }}</div>
        </div>
        <div class="col">
          <div class="key">{{ isRentalSalesOrders?$t('dms_device_detail_biz_info.fu_wu_shi_chang'):$t('dms_device_detail_biz_info.zu_lin_shi_chang') }}</div>
          <div class="val">
            <template v-if="bizInfo.rentalTerm">{{ bizInfo.rentalTerm }} ({{ getDicValue('rental_term_unit', bizInfo.rentalTermUnit) || '-' }})</template>
            <template v-else>-</template>
          </div>
          <!-- <div class="val">{{ bizInfo.rentalTerm  || '-'}}  ({{getDicValue('rental_term_unit',bizInfo.rentalTermUnit)|| '-'}})</div> -->
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.dao_qi_shi_jian') }}</div>
          <div class="val">{{ momentAmPm($momentLocal(bizInfo.rentalEndTime) || '-') }}</div>
        </div>
        <div class="col" v-if="isRentalSalesOrders">
          <div class="key">{{ $t('dms_device_detail_biz_info.sjdqsj') }}</div>
          <div class="val">{{ momentAmPm($momentLocal(bizInfo.simEndTime) || '-') }}</div>
        </div>
        <div class="col" v-else>
          <div class="key">{{ $t('dms_device_detail_biz_info.zhi_fu_zhou_qi') }}</div>
          <div class="val">{{ getDicValue('crm_payment_period', bizInfo.paymentPeriod) || '-' }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.dai_li_gong_si') }}</div>
          <div class="val">{{ bizInfo.agentCoName || '-' }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.ye_wu_yuan') }}</div>
          <div class="val">
            <template v-if="bizInfo.salesman">{{ bizInfo.salesman }}（{{ bizInfo.salesmanPhone || '-' }}）</template>
            <template v-else>-</template>
          </div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.shou_hou_gong_si') }}</div>
          <div class="val">{{ bizInfo.afterServiceName }}</div>
        </div>
        <div class="col">
          <div class="key">{{ $t('dms_device_detail_biz_info.shou_hou_fu_ze_ren') }}</div>
          <div class="val">{{ bizInfo.technicianName }} {{ bizInfo.technicianPhone || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    bizType() {
      return this.$store.state.userInfo.bizType;
    },
    isRentalSalesOrders() {
      return `${this.bizInfo.orderClass}` === '40';
    },
  },
  data() {
    return {
      bizInfo: {},
      // leaseInfo: {},
      afterSale: {},
    };
  },
  methods: {
    getDeviceInfo() {
      this.$getJSON(apis.DeviceResumeBizInfo, { bodyNum: this.deviceInfo.bodyNum }).then((res) => {
        this.bizInfo = res.data;
      });
    },
    // getLeaseInfo() {
    //   // 有订单号才请求
    //   if (!this.deviceInfo.orderId) {
    //     return;
    //   }
    //   this.$getJSON(apis.rmsOrderDeviceInfo, { bodyNum: this.deviceInfo.bodyNum, orderId: this.deviceInfo.orderId }).then(
    //     (res) => {
    //       this.leaseInfo = res.data;
    //     }
    //   );
    // }
  },
  mounted() {
    this.getDeviceInfo();
    // this.getLeaseInfo();
  },
};
</script>

<style lang="scss" scoped>
.detail-biz-info {
  padding: 0 24px 24px;
  .base-item {
    font-size: 12px;
    padding-bottom: 32px;
    border-bottom: 1px solid #eef2f8;

    &:nth-child(n + 2) {
      margin-top: 7px;
    }

    overflow: hidden;
    .title {
      color: #0d9ae0;
      font-weight: bold;
      line-height: 16px;
      margin-top: 24px;
    }
    .row {
      overflow: hidden;
      .col {
        float: left;
        width: 250px;
        margin-top: 24px;
        &.long {
          width: 100%;
        }
        .key {
          color: #98a6ad;
          line-height: 16px;
        }
        .val {
          margin-top: 8px;
          font-weight: bold;
          color: #495057;
        }
        .detail {
          color: #0d9ae0;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    .table-bd {
      margin-top: 24px;
    }
  }
}
</style>
